import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-049447bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "side-block" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "drawer-title" }, "图片库", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("管理图片")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-weight":"600"} }, "分组", -1))
const _hoisted_5 = { class: "group-block" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "group-block group-block-img" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "pic-title" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    t: "1637563771695",
    class: "icon",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "8244",
    width: "20",
    height: "20"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M694.037333 213.333333v64H234.666667v469.333334h512V512h64v234.666667a64 64 0 0 1-64 64H234.666667a64 64 0 0 1-64-64V277.333333a64 64 0 0 1 64-64h459.370666z m136.746667 24.234667l45.098667 45.397333-343.722667 341.290667 0.128 0.128-46.592 1.578667 1.322667-47.274667 0.085333 0.106667 343.68-341.226667z",
      "p-id": "8245",
      fill: "#67C23A"
    })
  ])
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "drawer-title" }, "话术库", -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("管理话术")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-weight":"600"} }, "分组", -1))
const _hoisted_15 = { class: "group-block" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { style: {"max-height":"580px","overflow":"auto"} }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "drawer-title" }, "图文库", -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode("管理图文")
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-weight":"600"} }, "分组", -1))
const _hoisted_22 = { class: "group-block" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { style: {"max-height":"580px","overflow":"auto"} }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { class: "color-title" }
const _hoisted_28 = {
  key: 0,
  class: "related-container"
}
const _hoisted_29 = { class: "related-title" }
const _hoisted_30 = { class: "related-desc" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "related-second-title" }, "方案解析：", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "related-second-title" }, "小建议：", -1))
const _hoisted_33 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tabs, {
      style: {"margin-left":"16px"},
      modelValue: _ctx.activeName,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.activeName) = $event)),
      onTabClick: _ctx.tabChange
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "图片",
          name: "img"
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createElementVNode("div", null, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.search,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                onChange: _ctx.searchList,
                onKeyup: _withKeys(_ctx.searchList, ["enter"]),
                placeholder: "请输入图片名称",
                style: {"width":"50%","margin-right":"30px"}
              }, null, 8, ["modelValue", "onChange", "onKeyup"]),
              _createVNode(_component_el_button, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.manageMaterial('img')))
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createElementVNode("div", null, [
                _hoisted_4,
                _createElementVNode("p", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupList, (item) => {
                    return (_openBlock(), _createElementBlock("span", {
                      class: "groupItem",
                      key: item.id,
                      onClick: ($event: any) => (_ctx.groupClick(item)),
                      style: _normalizeStyle({
                  color: _ctx.selectedId == item.id ? '#409EFF' : 'black',
                })
                    }, _toDisplayString(item.mouldGroupName), 13, _hoisted_6))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mouldList.filter((x) => x.mouldType == '图片'), (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id,
                      class: "img-block",
                      onClick: ($event: any) => (_ctx.contentClick(item, '图片'))
                    }, [
                      _createElementVNode("img", {
                        class: "img-item",
                        src: 
                    'https://facemaster.meb.fit/api/face/getOssImage?fileName=' +
                    item.mouldImgName[0]
                  
                      }, null, 8, _hoisted_9),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", null, _toDisplayString(item.mouldTitle), 1),
                        _hoisted_11
                      ])
                    ], 8, _hoisted_8))
                  }), 128))
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "话术",
          name: "text"
        }, {
          default: _withCtx(() => [
            _hoisted_12,
            _createElementVNode("div", null, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.search,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search) = $event)),
                onChange: _ctx.searchList,
                onKeyup: _withKeys(_ctx.searchList, ["enter"]),
                placeholder: "请输入话术名称",
                style: {"width":"50%","margin-right":"30px"}
              }, null, 8, ["modelValue", "onChange", "onKeyup"]),
              _createVNode(_component_el_button, {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.manageMaterial('text')))
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }),
              _createElementVNode("div", null, [
                _hoisted_14,
                _createElementVNode("p", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupList, (item) => {
                    return (_openBlock(), _createElementBlock("span", {
                      class: "groupItem",
                      key: item.id,
                      onClick: ($event: any) => (_ctx.groupClick(item)),
                      style: _normalizeStyle({
                  color: _ctx.selectedId == item.id ? '#409EFF' : 'black',
                })
                    }, _toDisplayString(item.mouldGroupName), 13, _hoisted_16))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mouldList.filter((x) => x.mouldType == '话术'), (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "text-block",
                  key: item.id,
                  onClick: ($event: any) => (_ctx.contentClick(item, '话术'))
                }, [
                  _createElementVNode("p", null, _toDisplayString(item.mouldTitle), 1),
                  _createElementVNode("p", null, _toDisplayString(item.mould), 1)
                ], 8, _hoisted_18))
              }), 128))
            ])
          ]),
          _: 1
        }),
        (_ctx.isWorkbench)
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 0,
              label: "图文",
              name: "mix"
            }, {
              default: _withCtx(() => [
                _hoisted_19,
                _createElementVNode("div", null, [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.search,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.search) = $event)),
                    onChange: _ctx.searchList,
                    onKeyup: _withKeys(_ctx.searchList, ["enter"]),
                    placeholder: "请输入图文名称",
                    style: {"width":"50%","margin-right":"30px"}
                  }, null, 8, ["modelValue", "onChange", "onKeyup"]),
                  _createVNode(_component_el_button, {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.manageMaterial('mix')))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_20
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", null, [
                    _hoisted_21,
                    _createElementVNode("p", _hoisted_22, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupList, (item) => {
                        return (_openBlock(), _createElementBlock("span", {
                          class: "groupItem",
                          key: item.id,
                          onClick: ($event: any) => (_ctx.groupClick(item)),
                          style: _normalizeStyle({
                  color: _ctx.selectedId == item.id ? '#409EFF' : 'black',
                })
                        }, _toDisplayString(item.mouldGroupName), 13, _hoisted_23))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mouldList.filter((x) => x.mouldType == '图文'), (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      style: {"height":"50px","overflow":"hidden"},
                      class: "text-block",
                      key: item.id,
                      onClick: ($event: any) => (_ctx.contentClick(item, '图文'))
                    }, [
                      _createElementVNode("p", null, _toDisplayString(item.mouldTitle), 1),
                      _createElementVNode("p", {
                        style: {"width":"200px"},
                        innerHTML: item.mould
                      }, null, 8, _hoisted_26)
                    ], 8, _hoisted_25))
                  }), 128))
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.isWorkbench)
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 1,
              label: "颜色",
              name: "color"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  onChange: _ctx.colorChange,
                  modelValue: _ctx.colorSetting,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.colorSetting) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mouldList.filter((x) => x.mouldType == '颜色'), (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "color-block",
                        key: item.id
                      }, [
                        _createVNode(_component_el_radio, {
                          label: item.mouldTitle
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", _hoisted_27, _toDisplayString(item.mouldTitle), 1),
                            _createElementVNode("div", {
                              class: "color-item",
                              style: _normalizeStyle(_ctx.convertCss(item.mould))
                            }, null, 4)
                          ]),
                          _: 2
                        }, 1032, ["label"])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["onChange", "modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.isWorkbench)
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 2,
              label: "关联信息",
              name: "relatedMsg"
            }, {
              default: _withCtx(() => [
                (_ctx.relatedMsg)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relatedMsg, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.name,
                          class: "related-block"
                        }, [
                          _createElementVNode("p", _hoisted_29, _toDisplayString(item.name), 1),
                          _createElementVNode("p", _hoisted_30, _toDisplayString(item.desc), 1),
                          _hoisted_31,
                          _createElementVNode("p", null, _toDisplayString(item.content), 1),
                          _hoisted_32,
                          _createElementVNode("p", null, _toDisplayString(item.suggest), 1)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createVNode(_component_el_empty, { description: "暂无关联信息" })
                    ]))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "onTabClick"])
  ]))
}